import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { mapCaptions } from '../../../../../utils';

import { AddedProductResponsiveItemFixedIncomeProps } from '.';

export const AddedProductItemFixedIncomeMobile: React.FC<
  AddedProductResponsiveItemFixedIncomeProps
> = (props) => {
  const {
    data,
    inputIsFocused,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    onRemoveProduct,
    selectedFee,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  } = props;

  return (
    <VStack w="full" space="inset.nano">
      <VStack w="full" space="inset.nano">
        <TableContentItemText variant="bold" fontSize={Typography['fontsize.lg']}>
          {data.productDisplayNormalized}
        </TableContentItemText>
        <TableContentItemCaptions forceDesktop icons={mapCaptions(data)} />
      </VStack>
      <VStack space="stack.nano" w="full">
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={data.riskRatingLevel || 0}
            tooltip={data.riskRatingName || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>IR</TableContentItemText>
          <TableContentItemText>{data.incomeTaxAmountNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn alignItems="center" direction="row" justifyContent="space-between">
          <TableContentItemText>Rentabilidade anual</TableContentItemText>
          <TableContentItemText>
            {selectedFee?.profitability || data.profitabilityFormattedNormalized}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Vencimento</TableContentItemText>
          <TableContentItemText>{data.maturityDateNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Taxa</TableContentItemText>
          <TableContentItemText>
            {selectedFee?.customerFeeAmountFormatted || '--'}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Preço unitário</TableContentItemText>
          <TableContentItemText>
            {selectedFee?.customerPuAmountFormatted || '--'}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Fee</TableContentItemText>
          <TableContentItemText>{selectedFee?.honorariumFee}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Receita estimada</TableContentItemText>
          <TableContentItemText>{Utils.Mask.Money(estimatedIncomeCalculated)}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn direction="row" alignItems="center" justifyContent="space-between">
          <TableContentItemText>Liquido estimado no vencimento</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.Money(estimatedNetValueCalculated)}
          </TableContentItemText>
        </TableContentItemColumn>
      </VStack>
      <TableContentItemColumn space="inline.quarck" flex={1} w="full">
        <TableContentItemText>Valor a aplicar:</TableContentItemText>
        <HStack w="full" alignContent="center" space="stack.xxxs">
          <VStack flex={1}>
            <InputMoney {...inputMoneyDataProps} />
            {messageAdjustUnitPriceIsVisible && !inputIsFocused && (
              <TableContentItemText fontSize={Typography['fontsize.xs']} color="neutral.light">
                Ajustado por preço unitário
              </TableContentItemText>
            )}
          </VStack>
          <IconButton
            testId="icon-button"
            onPress={onRemoveProduct}
            borderRadius={BoxRadius.sm}
            icon="Trash"
            p={0}
            iconColor={Color['feedback.error.default']}
            iconSize="xs"
          />
        </HStack>
      </TableContentItemColumn>
    </VStack>
  );
};
